import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from "../auth/AuthContext";
function siteLabel(c) {
    const name = (c.display_name || "").trim();
    if (!name || name === c.slug)
        return c.slug;
    return `${name} [${c.slug}]`;
}
export default function CustomerSelector() {
    const { user, selectedCustomer, setSelectedCustomer } = useAuth();
    if (!user)
        return null;
    if (user.accessible_customers.length <= 1) {
        const only = user.accessible_customers[0];
        return only ? _jsx("span", { className: "customer-pill", children: siteLabel(only) }) : null;
    }
    return (_jsx("select", { className: "customer-selector", value: selectedCustomer ?? "", onChange: (e) => setSelectedCustomer(e.target.value), children: user.accessible_customers.map(c => (_jsx("option", { value: c.slug, children: siteLabel(c) }, c.slug))) }));
}
